import { ComponentProps } from "react";
import * as S from "./styles";

interface IInputCheck extends ComponentProps<"input"> {
  text: string;
}

export const InputCheck = ({ text, ...rest }: IInputCheck) => {
  return (
    <S.Container>
      <S.MyInput {...rest} type="checkbox" />
      {text && <span>{text}</span>}
    </S.Container>
  );
};
